import { FC } from 'react';

import { Button, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { CardCommonContent } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/CardCommonContent/CardCommonContent';

import { setIsCropImageModalVisible } from 'store/models/createBanner';
import { useDispatch } from 'store/utils';

const TrlKeys = {
    title: 'AdCreate.AdForm.AdSources.SourceDisableCard.LowImgRes.title',
    text: 'AdCreate.AdForm.AdSources.SourceDisableCard.LowImgRes.text',
    button: 'AdCreate.AdForm.AdSources.SourceDisableCard.LowImgRes.button',
};

export const LowImgResCard: FC = () => {
    const trls = useTrls();
    const dispatch = useDispatch();

    return (
        <CardCommonContent title={trls(TrlKeys.title)} text={trls(TrlKeys.text)} style="negative-secondary">
            <VSpacing default={20} />
            <Button
                mode="primary"
                style="neutral"
                size="small"
                onClick={() => dispatch(setIsCropImageModalVisible(true))}
                data-qa="show-crop-from-source-disable-card"
            >
                {trls(TrlKeys.button)}
            </Button>
        </CardCommonContent>
    );
};
